import { TSalesManager } from '@internal/services/TSalesManager';
import { Typography } from '@renderer-ui-library/mui';
import React from 'react';
import { ProfilePicture } from '../Media/ProfilePicture';
import styles from './salesManagerContact.module.scss';

interface Props {
    salesManager: TSalesManager;
}

export const SalesManagerContact: React.FC<Props> = React.memo(
    ({ salesManager }) => {
        return (
            <div className={styles.salesConatiner}>
                <ProfilePicture
                    className={styles.image}
                    salesManager={salesManager}
                    variant="avatar"
                    size={64}
                />
                <Typography variant="body2">
                    {salesManager.firstName} {salesManager.lastName}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                    {salesManager.jobTitle}
                </Typography>
            </div>
        );
    },
);

SalesManagerContact.displayName = 'SalesManagerContact';
